<!-- CONCENTRATION PER STATE -->

<!-- TEST Graph -->

<!-- CARROUSEL OF GRAPHS -->
<!-- We shouldn't use this code -->
<p-carousel [value]="charts" [numVisible]="1" [numScroll]="1">
  <ng-template let-chart pTemplate="item">
    <div class="m-auto">
      <app-concentration-general-overview [concentration]="chart" />
    </div>
  </ng-template>
</p-carousel>

<!-- This is broken but we need to make it work -->
<!-- <p-carousel [value]="decodedCharts" [numVisible]="1" [numScroll]="1">
  <ng-template let-chart pTemplate="item">
    <div class="m-auto">
      <internal-chart [data]="chart"></internal-chart>
    </div>
  </ng-template>
</p-carousel> -->
